import React from 'react';
import './style.scss';

const CustomIcon = (props) => {
  const {
    src, alt = 'alt', height = '18px', rotate = '0', wrapperStyle, width = 'auto',
  } = props;
  return (
    <div className="icon_wrapper" style={{ ...wrapperStyle }}>
      <img
        src={src}
        alt={alt}
        style={{
          height, transform: `rotate(${rotate}deg)`, width,
        }}
      />
    </div>
  );
};

export { CustomIcon };



// WEBPACK FOOTER //
// ./src/view/common/CustomIcon/index.jsx